export default __webpack_public_path__ + "static/media/algo-visualizer.ca3f9ff1.png";